//
//
//
//
//
//
//
//

export default {
  name: "app",
  data() {
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/App.vue